import { AlertIcon1 } from './AlertIcon1'
import { AlertIcon10 } from './AlertIcon10'
import { AlertIcon11 } from './AlertIcon11'
import { AlertIcon12 } from './AlertIcon12'
import { AlertIcon13 } from './AlertIcon13'
import { AlertIcon14 } from './AlertIcon14'
import { AlertIcon15 } from './AlertIcon15'
import { AlertIcon16 } from './AlertIcon16'
import { AlertIcon17 } from './AlertIcon17'
import { AlertIcon18 } from './AlertIcon18'
import { AlertIcon19 } from './AlertIcon19'
import { AlertIcon2 } from './AlertIcon2'
import { AlertIcon20 } from './AlertIcon20'
import { AlertIcon21 } from './AlertIcon21'
import { AlertIcon22 } from './AlertIcon22'
import { AlertIcon23 } from './AlertIcon23'
import { AlertIcon24 } from './AlertIcon24'
import { AlertIcon25 } from './AlertIcon25'
import { AlertIcon26 } from './AlertIcon26'
import { AlertIcon27 } from './AlertIcon27'
import { AlertIcon28 } from './AlertIcon28'
import { AlertIcon29 } from './AlertIcon29'
import { AlertIcon3 } from './AlertIcon3'
import { AlertIcon30 } from './AlertIcon30'
import { AlertIcon31 } from './AlertIcon31'
import { AlertIcon32 } from './AlertIcon32'
import { AlertIcon33 } from './AlertIcon33'
import { AlertIcon34 } from './AlertIcon34'
import { AlertIcon35 } from './AlertIcon35'
import { AlertIcon36 } from './AlertIcon36'
import { AlertIcon37 } from './AlertIcon37'
import { AlertIcon38 } from './AlertIcon38'
import { AlertIcon39 } from './AlertIcon39'
import { AlertIcon4 } from './AlertIcon4'
import { AlertIcon40 } from './AlertIcon40'
import { AlertIcon41 } from './AlertIcon41'
import { AlertIcon42 } from './AlertIcon42'
import { AlertIcon43 } from './AlertIcon43'
import { AlertIcon44 } from './AlertIcon44'
import { AlertIcon45 } from './AlertIcon45'
import { AlertIcon46 } from './AlertIcon46'
import { AlertIcon47 } from './AlertIcon47'
import { AlertIcon48 } from './AlertIcon48'
import { AlertIcon49 } from './AlertIcon49'
import { AlertIcon5 } from './AlertIcon5'
import { AlertIcon50 } from './AlertIcon50'
import { AlertIcon51 } from './AlertIcon51'
import { AlertIcon52 } from './AlertIcon52'
import { AlertIcon53 } from './AlertIcon53'
import { AlertIcon54 } from './AlertIcon54'
import { AlertIcon55 } from './AlertIcon55'
import { AlertIcon56 } from './AlertIcon56'
import { AlertIcon57 } from './AlertIcon57'
import { AlertIcon58 } from './AlertIcon58'
import { AlertIcon59 } from './AlertIcon59'
import { AlertIcon6 } from './AlertIcon6'
import { AlertIcon60 } from './AlertIcon60'
import { AlertIcon61 } from './AlertIcon61'
import { AlertIcon62 } from './AlertIcon62'
import { AlertIcon63 } from './AlertIcon63'
import { AlertIcon64 } from './AlertIcon64'
import { AlertIcon65 } from './AlertIcon65'
import { AlertIcon66 } from './AlertIcon66'
import { AlertIcon67 } from './AlertIcon67'
import { AlertIcon68 } from './AlertIcon68'
import { AlertIcon69 } from './AlertIcon69'
import { AlertIcon7 } from './AlertIcon7'
import { AlertIcon70 } from './AlertIcon70'
import { AlertIcon71 } from './AlertIcon71'
import { AlertIcon72 } from './AlertIcon72'
import { AlertIcon73 } from './AlertIcon73'
import { AlertIcon74 } from './AlertIcon74'
import { AlertIcon75 } from './AlertIcon75'
import { AlertIcon76 } from './AlertIcon76'
import { AlertIcon77 } from './AlertIcon77'
import { AlertIcon78 } from './AlertIcon78'
import { AlertIcon79 } from './AlertIcon79'
import { AlertIcon8 } from './AlertIcon8'
import { AlertIcon9 } from './AlertIcon9'

export default {
  AlertIcon1,
  AlertIcon2,
  AlertIcon3,
  AlertIcon4,
  AlertIcon5,
  AlertIcon6,
  AlertIcon7,
  AlertIcon8,
  AlertIcon9,
  AlertIcon10,
  AlertIcon11,
  AlertIcon12,
  AlertIcon13,
  AlertIcon14,
  AlertIcon15,
  AlertIcon16,
  AlertIcon17,
  AlertIcon18,
  AlertIcon19,
  AlertIcon20,
  AlertIcon21,
  AlertIcon22,
  AlertIcon23,
  AlertIcon24,
  AlertIcon25,
  AlertIcon26,
  AlertIcon27,
  AlertIcon28,
  AlertIcon29,
  AlertIcon30,
  AlertIcon31,
  AlertIcon32,
  AlertIcon33,
  AlertIcon34,
  AlertIcon35,
  AlertIcon36,
  AlertIcon37,
  AlertIcon38,
  AlertIcon39,
  AlertIcon40,
  AlertIcon41,
  AlertIcon42,
  AlertIcon43,
  AlertIcon44,
  AlertIcon45,
  AlertIcon46,
  AlertIcon47,
  AlertIcon48,
  AlertIcon49,
  AlertIcon50,
  AlertIcon51,
  AlertIcon52,
  AlertIcon53,
  AlertIcon54,
  AlertIcon55,
  AlertIcon56,
  AlertIcon57,
  AlertIcon58,
  AlertIcon59,
  AlertIcon60,
  AlertIcon61,
  AlertIcon62,
  AlertIcon63,
  AlertIcon64,
  AlertIcon65,
  AlertIcon66,
  AlertIcon67,
  AlertIcon68,
  AlertIcon69,
  AlertIcon70,
  AlertIcon71,
  AlertIcon72,
  AlertIcon73,
  AlertIcon74,
  AlertIcon75,
  AlertIcon76,
  AlertIcon77,
  AlertIcon78,
  AlertIcon79
}
